<template>
    <div class="merchant page-sales">
        <div id="dne"></div>
        <Header :dataSource="headerTemplate" />

        <!-- HEADER STORE -->
        <div class="load" v-if="loadMerchantStore"></div>
        <HeaderStore :dataSource="dataMerchantStore" v-if="!loadMerchantStore" />
        

        <!-- BREADCRUMB -->
        <Breadcrumb :dataSource="breadcrumb" />

        
        <!-- CONTENT -->
        <section class="content-sales">
            
            <div class="container">
                <div class="cont-sales">
                    <h2 class="title-secondary subtitle">
                        <!-- <small>{{storeName}}</small> -->
                        {{getMyLanguage("Merchant","sales.title")}}
                    </h2>

                    <div class="load" v-if="sectionManage.load"></div>

                    <div class="row" v-if="errorsGet.dataSales != false">
                        <div class="col-12">
                            <div class="box box-error">
                                <h3 class="title-secondary">
                                    {{getMyLanguage("box-error","title-error")}}
                                </h3>

                                <p v-if='errorsGet.dataSales != "401"'>
                                    {{getMyLanguage("box-error","msg-error")}}
                                </p>

                                <p v-if='errorsGet.dataSales == "401"'>
                                    {{getMyLanguage("box-error","401")}}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="search-bar" data-aos="fade-up" data-aos-offset="-100" v-if="!sectionManage.load && !errorsGet.dataSales && dataSales.length > 0">
                        <input type="search" inputmode="search" class="form form-search" id="searchSale"
                        @keyup="searchFilter"
                        :placeholder='getMyLanguage("Merchant", "products.placeholder.search")'>
                        
                        <div class="filter">
                            <div class="btn-filter" @click="advancedSearch.modal = true"></div>
                        </div>
                    </div>

                    <div class="sales" data-aos="fade-up" data-aos-offset="-100" v-if="!sectionManage.load && !errorsGet.dataSales && dataSales.length > 0">
                        <div class="sale" v-for="(purchase, indexPurchase) in dataSales" :key="indexPurchase" :id="`purchase${indexPurchase}`">
                            <div class="header-print">
                                <div class="logo-company">
                                    <div class="logo-dne-merchant"></div>
                                    <div class="partner">
                                        <h4><strong>{{purchase.store.name}}</strong></h4>
                                        <p>+351 222 222 222</p>
                                    </div>
                                </div>

                                <div class="content">
                                    <div class="buyer">
                                        <div class="name">
                                            <p><small>{{getMyLanguage("Account","purchases.purchase.buyers-name")}}</small></p>
                                            <p><strong>{{purchase.customer.full_name}}</strong></p>
                                        </div>

                                        <div class="email">
                                            <p><small>{{getMyLanguage("Account","purchases.purchase.buyers-email")}}</small></p>
                                            <p><strong>{{purchase.customer.email}}</strong></p>
                                        </div>

                                        <div class="phone-number">
                                            <p><small>{{getMyLanguage("Account","purchases.purchase.buyers-phone-number")}}</small></p>
                                            <p><strong>{{purchase.customer.phone_number}}</strong></p>
                                        </div>
                                    </div>

                                    <div class="shipping">
                                        <div class="address">
                                            <p><small>{{getMyLanguage("Account","purchases.purchase.buyers-shipping-address")}}</small></p>
                                            <p>
                                                <strong>
                                                    {{purchase.customer.address.address1}},&nbsp;
                                                    {{purchase.customer.address.number}}
                                                    <span v-if="purchase.customer.address.address2">
                                                        ,&nbsp;{{purchase.customer.address.address2}}
                                                    </span>
                                                    ,&nbsp;{{purchase.customer.address.postal_code}}
                                                    &nbsp;|&nbsp;{{purchase.customer.address.city}}
                                                    &nbsp;|&nbsp;{{purchase.customer.address.state}}
                                                    &nbsp;|&nbsp;{{purchase.customer.address.country}}
                                                </strong>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="order">
                                <div class="resume-sale">
                                    <div class="header-sale">
                                        <div class="buyer">
                                            <div>
                                                <small>{{getMyLanguage("Account","purchases.purchase.buyers-name")}}</small>
                                                <strong>{{purchase.customer.full_name}}</strong>
                                            </div>

                                            <div>
                                                <small>{{getMyLanguage("Account","purchases.purchase.buyers-email")}}</small>
                                                
                                                <a :href="`mailto:${purchase.customer.email}`">
                                                    <strong>{{purchase.customer.email}}</strong>
                                                </a>
                                            </div>
                                            
                                            <div>
                                                <small>{{getMyLanguage("Account","purchases.purchase.buyers-phone-number")}}</small>
                                                
                                                <a :href="`tel:${purchase.customer.phone_number}`">
                                                    <strong>{{purchase.customer.phone_number}}</strong>
                                                </a>
                                            </div>
                                        </div>

                                        <div class="date-status">
                                            <div>
                                                <small>{{getMyLanguage("Account","purchases.purchase.reference")}}</small>
                                                <strong>{{purchase.reference}}</strong>
                                            </div>

                                            <div class="date">
                                                <small>{{getMyLanguage("Account","purchases.purchase.purchase-date")}}</small>
                                                <strong>{{dateTime(purchase.created_at)}}</strong>
                                            </div>
                                            <div class="status" :class="purchase.status">
                                                <small>{{getMyLanguage("Account","purchases.purchase.status")}}</small>
                                                <strong>{{ getMyLanguage("Account","purchases.status." + purchase.status_extra) }}</strong>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="products">
                                        <div class="items"
                                            v-for="(item, indexItem) in purchase.items"
                                            :key="indexItem">

                                            <a :href="`/${flagSelected}/merchant/sales/${purchase.reference}`" class="items" target="_blank">

                                                <div class="item">
                                                    <div class="photo">
                                                        <img :src="item.product.attachment">
                                                    </div>

                                                    <div class="details">
                                                        <p class="name">{{item.product.name}}</p>

                                                        <div class="price">
                                                            <span>
                                                                {{item.price.toLocaleString("pt-PT", {minimumFractionDigits: "2", maximumFractionDigits: "4"})}}
                                                                <i></i>
                                                            </span>

                                                            <small v-if="(item.quantity = 1)">
                                                                ({{item.quantity}} {{getMyLanguage("Account","purchases.purchase.item")}})
                                                            </small>

                                                            <small v-if="(item.quantity > 1)">
                                                                ({{item.quantity}} {{getMyLanguage("Account","purchases.purchase.items")}})
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>

                                            <div class="shipping-carrier" v-if="item.shipping">
                                                <span>{{ getMyLanguage("Account", "purchases.status." + item.shipping.status_extra) }}</span>
                                                <span v-if="item.shipping.status_reason">{{item.shipping.status_reason}}</span>

                                                <span>Transportadora: <strong>{{item.shipping.carrier_name}}</strong></span>
                                                <span>Rastreamento: <a :href="item.shipping.carrier_url" target="_blank"><strong>{{item.shipping.carrier_url}}</strong></a></span>
                                                <span>Código: <strong>{{item.shipping.tracking_number}}</strong></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                    
                                <div class="box-summary">
                                    <div class="resume-purchase">
                                        <div>
                                            <p><small>{{getMyLanguage("Account","purchases.purchase.reference")}}</small></p>
                                            <p><strong>{{purchase.reference}}</strong></p>
                                        </div>

                                        <div>
                                            <p><small>{{getMyLanguage("Account","purchases.purchase.purchase-date")}}</small></p>
                                            <p><strong>{{dateTime(purchase.created_at)}}</strong></p>
                                        </div>
                                        
                                        <div>
                                            <p><small>{{getMyLanguage("Account","purchases.purchase.purchase-delivery-date")}}</small></p>
                                            <p><strong>{{dateTime(purchase.created_at)}}</strong></p>
                                        </div>
                                    </div>
                                    
                                    <table>
                                        <tr>
                                            <td><strong>{{getMyLanguage("Account","purchases.summary.products")}}</strong></td>
                                            
                                            <td>
                                                <span>
                                                    {{purchase.summary.items_price.toLocaleString("pt-PT", {minimumFractionDigits: "2", maximumFractionDigits: "4"})}}
                                                </span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td><strong>{{getMyLanguage("Account","purchases.summary.discount")}}</strong></td>
                                            
                                            <td>
                                                <span>
                                                    {{purchase.summary.discount.toLocaleString("pt-PT", {minimumFractionDigits: "2", maximumFractionDigits: "4"})}}
                                                </span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td><strong>{{getMyLanguage("Account","purchases.summary.subtotal")}}</strong></td>
                                            
                                            <td>
                                                <span>
                                                    {{purchase.summary.subtotal.toLocaleString("pt-PT", {minimumFractionDigits: "2", maximumFractionDigits: "4"})}}
                                                </span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td><strong>{{getMyLanguage("Account","purchases.summary.shipping")}}</strong></td>
                                            
                                            <td>
                                                <span>
                                                    {{purchase.summary.shipping.toLocaleString("pt-PT", {minimumFractionDigits: "2", maximumFractionDigits: "4"})}}
                                                </span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td><strong>{{getMyLanguage("Account","purchases.summary.tax")}}</strong></td>
                                            
                                            <td>
                                                <span>
                                                    {{purchase.summary.tax.toLocaleString("pt-PT", {minimumFractionDigits: "2", maximumFractionDigits: "4"})}}
                                                </span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td><strong>{{getMyLanguage("Account","purchases.summary.fee")}}</strong></td>
                                            
                                            <td>
                                                <span>
                                                    {{purchase.summary.fee.toLocaleString("pt-PT", {minimumFractionDigits: "2", maximumFractionDigits: "4"})}}
                                                </span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td><strong>{{getMyLanguage("Account","purchases.summary.total")}}</strong></td>
                                            
                                            <td>
                                                <span>
                                                    {{purchase.summary.total_amount.toLocaleString("pt-PT", {minimumFractionDigits: "2", maximumFractionDigits: "4"})}}
                                                </span>
                                            </td>
                                        </tr>

                                        <tr class="cashback">
                                            <td><strong>{{getMyLanguage("Account","purchases.summary.cashback")}}</strong></td>
                                            
                                            <td>
                                                <span>
                                                    {{purchase.summary.cashback.toLocaleString("pt-PT", {minimumFractionDigits: "2", maximumFractionDigits: "4"})}}
                                                </span>
                                            </td>
                                        </tr>
                                    </table>

                                    <div class="bts">
                                        <!-- <div class="download-pdf">
                                            <div @click="pdfPurchaseSingle(purchase.reference, indexPurchase)" class="btn-primary" v-html='getMyLanguage("Btn","download-pdf")'></div>
                                        </div> -->

                                        <div @click="pdfPurchaseSingle(purchase.reference, indexPurchase)" class="download-pdf">
                                            PDF
                                        </div>

                                        <a :href="`/${flagSelected}/merchant/sales/${purchase.reference}`" class="btn-details">
                                            Detalhes
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="box-empty" v-if="!sectionManage.load && dataSales.length == 0">
                        <h2 class="title-secondary">
                            {{ getMyLanguage("box-empty","title-empty.sales") }}
                        </h2>

                        <p>{{ getMyLanguage("box-empty","msg-empty.sales") }}</p>
                    </div>
                </div>

            </div>
        </section>
    </div>


    <!-- MODAL ADVANCED SEARCH -->
    <div class="modal" v-if="advancedSearch.modal">
        <div class="modal-cont">
            <div class="modal-close" @click="advancedSearch.modal = false"></div>
            <div class="modal-scroll">
                <h2 class="title-secondary">Busca avançada</h2>
                <div class="filters">
                    filtros....
                </div>
            </div>
        </div>
    </div>


    <!-- MODAL SALE PLUGIN -->
    <div class="modal" v-if="modalPlugin.show">
        <div class="modal-cont">
            <div class="modal-close" @click="closeModal()"></div>

            <div class="modal-scroll">
                <h2 class="title-secondary">
                    Atualizar
                </h2>

                <div class="fields">
                    <!-- STATUS -->
                    <div class="field">
                        <label>
                            <span class="info">
                                Status da compra
                                <i><span>Lorem ipsum dolor sit amet consectetur adipisicing elit.</span></i>
                            </span>

                            <select name="" id="" class="form">
                                <option value="">Active</option>
                                <option value="">Inactive</option>
                                <option value="">Done</option>
                                <option value="">Created</option>
                                <option value="">Pending</option>
                                <option value="">Approved</option>
                                <option value="">Paid</option>
                                <option value="">Denied</option>
                                <option value="">Cancelled</option>
                            </select>
                        </label>
                    </div>

                    <div class="bts center">
                        <div class="btn-primary">Atualizar status</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const $ = require('jquery')
    window.$ = $

    import Header from "@/components/Essentials/Header.vue";
    import HeaderStore from "@/components/Merchant/HeaderStore.vue";
    import Breadcrumb from "@/components/Merchant/Breadcrumb.vue";

    import getMyContentLanguage from "@/services/contentLanguage.js";

    import apiMerchant from '@/config/apiMerchant.js'

    import bus from '@/eventBus';

    import moment from 'moment';
    
    import { handleError } from '@/services/errorHandler.js'

    const html2pdf = require('html2pdf.js')

    export default {
        components: {
            Header,
            HeaderStore,
            Breadcrumb
        },

        data() {
            return {
                flagSelected: "en",
                headerTemplate: "merchant",
                breadcrumb: "",
                load: true,

                sectionManage: {
                    load: true,
                    guide: "sales",

                    loaded: {
                        sales: false,
                        plugin: false
                    }
                },
                
                dataSales: [],

                dataMerchantStore: {},
                loadMerchantStore: true,

                storeName: "",

                errorsGet: {
                    dataSales: false,
                },

                advancedSearch: {
                    modal: false,
                    aaa: ""
                },

                modalPlugin: {
                    show: false,
                    load: false,
                },
            }
        },

        async mounted() {
            this.languageSelected()

            // HEADER STORE
            await apiMerchant('/api/v1/market/store')
            .then(response => {
                setTimeout(() => {
                    this.dataMerchantStore = response.data.store
                    this.loadMerchantStore = false
                }, 500);
            })
            .catch(error => {
                setTimeout(() => {
                    this.errorsGet.dataMerchantStore = error.response.status
                    this.loadMerchantStore = false
                    localStorage.removeItem("storeReference")
                }, 500);
            })

            this.storeName = localStorage.getItem("storeName")


            // SALES
            this.loadSales()
                        

            this.breadcrumb = [
                {
                    slug: `${this.flagSelected}/merchant/dashboard`,
                    name: this.getMyLanguage("Merchant","breadcrumb.dashboard")
                },
                {
                    name: this.getMyLanguage("Merchant","breadcrumb.sales")
                }
            ]
        },

        methods: {
            languageSelected(){
                this.flagSelected = this.$store.state.SelectLanguage.code
            },

            getMyLanguage(group, code) {
                return getMyContentLanguage(group, code, this.$store.state.SelectLanguage.code);
            },

            dateTime(value) {
                const format = this.flagSelected === 'br' ? 'pt' : this.flagSelected;
                return moment.utc(value).locale(format).format('ll');
            },

            goTop(){
                $('html, body').animate({scrollTop : 0},200);
                return false;
            },

            async loadSales(){
                this.sectionManage.load = true

                try {
                    const responseSales = await apiMerchant.get('/api/v1/market/order/filter')

                    this.dataSales = responseSales.data
                    this.sectionManage.loaded.sales = true

                    setTimeout(() => {
                        this.sectionManage.load = false
                    }, 500);
                }
                catch (error) {
                    this.errorsGet.dataSales = JSON.stringify(error.response.status)
                    this.sectionManage.load = false
                    console.error(error)

                    if ( error.response.status == 401 ){
                        bus.emit('open-login',"401");
                    }

                    handleError(error, this.flagSelected, this.$store.state.profile.account_type);
                }
            },


            pdfPurchaseSingle(value, indexPurchase) {
                html2pdf(document.getElementById(`purchase${indexPurchase}`), {
                    filename: `Receipt ${value} DNE Market`,
                    margin: 15
                });
            },



            // PLUGIN
            openModal(){
                this.modalPlugin.show = true
                this.modalPlugin.load = true

                setTimeout(() => {
                    this.modalPlugin.load = false
                }, 500);
            },

            closeModal(){
                this.modalPlugin.show = false
            },
        },

        watch: {
            '$store.state.SelectLanguage.code': {
                immediate: true,
                handler() {
                    this.languageSelected();
                }
            }
        },

        created() {
            const meta = document.querySelector('meta[name="robots"]')
            if (meta) {
                meta.content = 'noindex,nofollow'
            } else {
                const newMeta = document.createElement('meta')
                newMeta.name = 'robots'
                newMeta.content = 'noindex,nofollow'
                document.getElementsByTagName('head')[0].appendChild(newMeta)
            }
        },
    };
</script>

<style src="./custom-sales.scss" lang="scss" scoped />

<style lang="scss" scoped>
    @import '@/assets/scss/_colors.scss';
    @import '@/assets/scss/_fonts.scss';

    .header-print{
        // margin-bottom: 20px;

        .logo-company{
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;

            .logo-dne-merchant{
                width: 30%;
                height: 70px;
                background: url('~@/assets/images/header/logo-dne-merchant.svg') no-repeat left center;
                background-size: auto 100%;
            }

            .partner{
                h4{
                    font-size: 20px;
                    line-height: 20px;
                    margin-bottom: 2px;
                }

                p{
                    margin-bottom: 0;
                    font-size: 12px;
                    line-height: 18px;
                }
            }
        }
        
        .content{    
            border: 1px solid #ccc;
            padding: 5px 15px 22px 15px;

            small{
                display: block;
                line-height: 12px;
                margin-bottom: 5px;
            }
            
            p{
                margin-bottom: 0;
                font-size: 12px;
                line-height: 18px;
            }

            .buyer{
                display: flex;
                width: 100%;
                margin-bottom: 20px;

                .email, .phone-number{
                    margin-left: 20px;
                }
            }
        }
    }

    .header-sale{
        display: none;
    }


    .products{
        margin-top: 40px;
        border: 1px solid #ccc;
        padding: 0 15px 22px 15px;

        .items{
            &:not(&:last-child){
                .item{
                    padding-bottom: 20px;
                    border-bottom: 1px solid #ccc;
                }
            }

            .item{
                position: relative;
                z-index: 5;
                display: flex;

    
                .photo{
                    display: none;
                }
    
                .details{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    width: 100%;
    
                    .name{
                        color: $color-text-primary;
                        font-family: $font-primary-semibold;
                        font-size: 13px;
                        margin-bottom: 3px;
                    }
    
                    .price{
                        display: flex;
                        width: 100%;
    
                        span{
                            display: block;
                            font-family: $font-primary-semibold;
                            color: $color-text-primary;
                            align-items: center;
                            height: 20px;
                            border-right: none;
                            font-size: 13px;
                            line-height: 20px;
                            margin-right: 15px;
                            padding-right: 21px;
                            background: url('~@/assets/images/icons/dne-symbol-pdf.png') no-repeat right right;
                            background-size: auto 12px;
                        }
    
                        small{
                            font-size: 12px;
                            line-height: 20px;
                        }
                    }
                }
            }
        }

        .shipping-carrier{
            display: block;
            padding: 0;
            margin-top: 0;
            background: #fff;

            span{
                display: flex;
                border-radius: 0;
                padding: 0;
                margin: 0.5rem 0;
                font-size: 13px;
                box-shadow: none;
                border: none;
                background: #fff;
                white-space: nowrap;

                strong{
                    padding-left: 5px;
                }
            }
        }
    }

    .box-summary{
        display: flex;
        justify-content: space-between;
        
        .resume-purchase{
            display: block;
            width: calc(50% - 10px);
            padding: 0 16px 6px;
            background: $color-text-tertiary;
            border: 1px solid #ccc;
            margin-top: 40px;

            div{
                margin-bottom: 15px;;

                p{
                    font-size: 16px;
                    margin: 0;

                    strong{
                        color: $color-primary;
                    }
                }
            }
        }
        
        table{
            width: calc(50% - 10px);
            padding: 0 16px 6px;
            background: $color-text-tertiary;
            border: 1px solid #ccc;
            margin-top: 40px;
            
            tr{
                &.cashback{
                    td{
                        border-bottom: none;
                    }
                }
    
                td{
                    border-bottom: 1px solid #ddd;
                    padding: 0;
    
                    &:nth-of-type(2){
                        text-align: right;
                    }
    
                    strong{
                        position: relative;
                        top: -5px;
                        display: block;
                        font-family: $font-primary-semibold;
                        font-size: 12px;
                        line-height: 12px;
                        height: 22px;
                        color: $color-text-primary;
                    }
                    
                    span{
                        position: relative;
                        top: -5px;
                        display: inline-flex;
                        font-family: $font-primary-semibold;
                        color: $color-text-primary;
                        font-size: 12px;
                        line-height: 12px;
                        height: 22px;
                        padding-right: 21px;
                        background: url('~@/assets/images/icons/dne-symbol-pdf.png') no-repeat right 10px;
                        background-size: auto 12px;
                    }
                }
            }
        }

        .bts{
            display: none;
        }
    }
</style>

<style>
    .download-pdf .btn-primary small{display: block; margin-left: 10px; font-size: 12px;}
</style>